import { Controller } from '@hotwired/stimulus';

export class FormToHistoryState extends Controller {
  push(event) {
    const formData = new FormData(event.target);

    event.target.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      if (checkbox.name.endsWith('[]')) {
        if (checkbox.checked) {
          formData.append(checkbox.name, checkbox.value);
        }
      } else {
        formData.set(checkbox.name, checkbox.checked);
      }
    });

    const params = new URLSearchParams(formData).toString();

    window.history.pushState({}, null, `?${params}`);
  }
}
